<template>
    <div class='p-card'>
        <div class='p-title'>{{cdata.title}}</div>
        <div v-if="cdata.img" class='p-image-wrapper'>
            <div class='p-image' :class="{ 'p-image-ln-overlay': cdata?.links?.length }">
                <div class='p-img-overlay'>
                    <a :href='cdata.links[0][1]' target='_blank'>{{cdata.links[0].length>2?cdata.links[0][2]:cdata.links[0][0]}}</a>
                </div>
                <img :src='cdata.img'>
            </div>
        </div>
        <div v-if="cdata.desc" class='p-desc'>
            <p v-for="(item, index) in cdata.desc.split('\n')" :key="index">{{item}}</p>
        </div>
        <hr v-if="cdata?.tags?.length">
        <div class='p-tags ns'  v-if="cdata?.tags?.length">
            <div class='p-tag' @click="$emit('filter_add', item)" v-for="(item, index) in cdata.tags" :key="index">{{item}}</div>
        </div>
        <hr v-if="cdata?.links?.length">
        <div class='p-footer' v-if="cdata?.links?.length">
            <div class='p-footer-item' v-for="(link, index) in cdata.links" :key="index">
                <img src=''>
                <a :href='link[1]' target='_blank'>{{link.length>2?link[2]:link[0]}}</a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ProjectCard',
    components: {},
    props: ['data'],
    setup(props) {
        const cdata = {
            title: props.data?.title || "No title",
            img: props.data?.img,
            links: props.data?.links || [],
            desc: props.data?.desc,
            tags: props.data?.tags || []
        }
        return {cdata}
    },
    methods: {
    },
}
</script>
<style>

    .p-card{
        background: rgba(0,28,58,1);
        border: solid white 0.1em;
        border-radius: 1em;
        max-width: 15em;

    }

    .p-card hr{
        width: 80%;
    }

    .p-tag{
        font-weight: 600;
        background: rgba(60,60,60,0.7);
        padding: 0.1em 0.4em;
        border-radius: 1em;
        margin: 0.2em;
        width: fit-content;
        cursor: pointer;
        transition: 
            background 200ms, 
            color 200ms,
            transform 100ms;
    }

    .p-tag:hover, .p-tag:active{
        background: rgba(220,220,220,0.7);
        color: rgba(60,60,60,1);
    }

    .p-tag:active{
        transform: scale(0.9);
    }

    .p-tags{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    .p-title{
        font-size:1.3em;
        margin-bottom: 0.5em;
        margin-top: 0.2em;
    }

    .p-desc{
        padding-inline: 0.6em;
    }

    .p-image{
        border:solid white 0.2em;
        border-radius: 100%;
        overflow: hidden;
        width: 10em;
        height: 10em;
        position: relative;
    }

    .p-image-wrapper{
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .p-card{
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding-inline: 0.3em;
        padding-bottom: 0.5em;
        padding-top: 0.2em;
    }

    .p-image>img{
        position:absolute;
        top:0;
        z-index:2;
        object-fit: cover;
        width: 100%;
        height: 100%;
    }

    .p-img-overlay{
        position: absolute;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: center;
        top:-120%;
        width:100%;
        height:120%;
        z-index:4;
        background: rgba(60,60,60,0.5);
        transition: top 200ms cubic-bezier(.68,-0.55,.27,1.55);
    }

    .p-image-ln-overlay:hover .p-img-overlay{
        top:-10%;
    }

    .p-image-ln-overlay a, .p-footer-item a{
        text-decoration: none;
        color: white;
        transition: transform 300ms cubic-bezier(.68,-0.55,.27,1.55);
    }

    .p-image-ln-overlay a:hover{
        transform: scale(1.1);
    }

    .p-image-ln-overlay:hover img{
        filter: blur(5px);
    }
</style>